var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.ready && !_vm.hiding)?_c('div',{staticClass:"app-main",class:[{ 'octadesk-app-popup': _vm.isPopup }, _vm.currentUserAgent]},[_c('ButtonSvg'),(_vm.visibleButton)?_c('Button',{attrs:{"custom-class":_vm.classStories}}):_vm._e(),(_vm.proactiveMessageShowCondition)?_c('ProactiveMessage'):_vm._e(),(_vm.settings)?_c('div',{staticClass:"octadesk-app-window",class:[
      `octadesk-app-window--${_vm.settings.position}`,
      {
        'octadesk-app-window-closed': !_vm.active,
        'octadesk-app-window-opened': _vm.active
      }
    ]},[(_vm.showLoaderContainer)?_c('div',{class:_vm.$style['loader-container']},[(_vm.restoringSession)?_c('WidgetLoader'):(_vm.isLoading)?_c('WidgetLoader',{attrs:{"i18n-key-message":"loading"}}):_vm._e()],1):_c('router-view')],1):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }